import { PayloadAction } from "@reduxjs/toolkit";
import { INotify, NotifyType } from "../../model/user-info.interface";
import { IRequestState } from "../request.state.interface";
import { CustomNotifyType } from "../../components/Modal/ModalNotify/Custom/CustomNotifyRouter";
import { LoginResponse } from "../user/login.handler";

interface INotificationsState extends IRequestState {
    items: INotify[];
}

export const loginFulfilledForNotificationsHandler = (state: INotificationsState, action: PayloadAction<LoginResponse>) => {
    let notifications = action.payload.user.notifications || [];

    const customNotifications = [];
    if (!action.payload.user.allowWrite && !action.payload.user.isFirstLaunch) {
        customNotifications.push({
            type: NotifyType.Custom,
            customType: CustomNotifyType.NotAllowWrite,
        });
    }

    if (action.payload.user.isFirstLaunch) {
        customNotifications.push({
            type: NotifyType.Custom,
            customType: CustomNotifyType.ChallengeIntro,
        });
    }

    customNotifications.forEach(notify => notifications.push(notify as unknown as INotify));
    state.items = notifications;

    if (state.items) {
        state.items.sort((a, b) => a.type - b.type);
    }
};
